export default "__VITE_ASSET__BosV4uRs__"